import {
  FunctionComponent,
} from 'react';
import { Route } from 'react-router-dom';

import { AdminRouteName } from '../../CONSTANTS';
import AllGuarantees from './AllGuarantees';
import AwaitingPaymentGuarantees from './AwaitingPaymentGuarantees';
import AwaitingApprovalGuarantees from './AwaitingApprovalGuarantees';
import PaidGuarantees from './PaidGuarantees';
import DeclinedGuarantees from './DeclinedGuarantees';
import OnGoingGuarantees from './OnGoingGuarantees';
import DashboardWrap from '../../../components/DashboardWrap';

import './guarantees.scss';

const MainRentGuarantees: FunctionComponent = () => {
  const TabsRaw = [
    {
      id: 1, name: 'All Guarantees', link: AdminRouteName.allMainGuaranteesRoute, permission: 'can-view-all-guarantees-tab',
    },
    {
      id: 2, name: 'Awaiting Payment Guarantees', link: AdminRouteName.awaitingPaymentGuaranteesRoute, permission: 'can-view-awaiting-payment-guarantees',
    },
    {
      id: 3, name: 'Awaiting Approval Guarantees', link: AdminRouteName.awaitingApprovalGuaranteesRoute, permission: 'can-view-awaiting-approval-guarantees',
    },
    {
      id: 4, name: 'Ongoing Payment Guarantees', link: AdminRouteName.ongoingGuaranteesRoute, permission: 'can-view-awaiting-payment-guarantees',
    },
    {
      id: 5, name: 'Paid Guarantees', link: AdminRouteName.paidGuaranteesRoute, permission: 'can-view-paid-guarantees',
    },
    {
      id: 6, name: 'Declined Guarantees', link: AdminRouteName.declinedGuaranteesRoute, permission: 'can-view-declined-guarantees',
    },
  ];
  return (
    <DashboardWrap>
      <div className="main-guarantee-root-cover">
        <Route
          render={(routeProps) => (
            <AllGuarantees {...routeProps} TabsRaw={TabsRaw} />
          )}
          path={AdminRouteName.allMainGuaranteesRoute}
          exact
        />

        <Route
          render={(routeProps) => (
            <AwaitingPaymentGuarantees {...routeProps} TabsRaw={TabsRaw} />
          )}
          path={AdminRouteName.awaitingPaymentGuaranteesRoute}
        />
        <Route
          render={(routeProps) => (
            <AwaitingApprovalGuarantees {...routeProps} TabsRaw={TabsRaw} />
          )}
          path={AdminRouteName.awaitingApprovalGuaranteesRoute}
        />
        <Route
          render={(routeProps) => (
            <OnGoingGuarantees {...routeProps} TabsRaw={TabsRaw} />
          )}
          path={AdminRouteName.ongoingGuaranteesRoute}
        />
        <Route
          render={(routeProps) => (
            <PaidGuarantees {...routeProps} TabsRaw={TabsRaw} />
          )}
          path={AdminRouteName.paidGuaranteesRoute}
        />
        <Route
          render={(routeProps) => (
            <DeclinedGuarantees {...routeProps} TabsRaw={TabsRaw} />
          )}
          path={AdminRouteName.declinedGuaranteesRoute}
        />
      </div>
    </DashboardWrap>
  );
};

export default MainRentGuarantees;
